import { TabEnum, PAGE_LIMIT, selectTypeInitialValues } from 'constants/index';
import { CapsulePricesPayload } from 'generated/graphql';
import { SelectType } from 'interfaces';

export type State = {
  page: number;
  count: number;
  search: string;
  activeTab: TabEnum;
  rowsPerPage: number;
  density: SelectType;
  supplier: SelectType;
  capsuleType: SelectType;
  productSize: SelectType;
  data: CapsulePricesPayload['data'];
};

export const initialState: State = {
  page: 1,
  count: 0,
  data: [],
  search: '',
  rowsPerPage: PAGE_LIMIT,
  activeTab: TabEnum.Active,
  density: selectTypeInitialValues,
  supplier: selectTypeInitialValues,
  capsuleType: selectTypeInitialValues,
  productSize: selectTypeInitialValues,
};

export enum ActionType {
  SET_PAGE = 'setPage',
  SET_DATA = 'setData',
  SET_COUNT = 'setCount',
  SET_SEARCH = 'setSearch',
  SET_DENSITY = 'setDensity',
  SET_SUPPLIER = 'setSupplier',
  SET_ACTIVE_TAB = 'setActiveTab',
  SET_CAPSULE_TYPE = 'setCapsuleType',
  SET_PRODUCT_SIZE = 'setProductSize',
  SET_ROWS_PER_PAGE = 'setRowsPerPage',
}

export type Action =
  | { type: ActionType.SET_PAGE; page: State['page'] }
  | { type: ActionType.SET_COUNT; count: State['count'] }
  | { type: ActionType.SET_DATA; data: State['data'] }
  | { type: ActionType.SET_SEARCH; search: State['search'] }
  | { type: ActionType.SET_ACTIVE_TAB; activeTab: State['activeTab'] }
  | { type: ActionType.SET_ROWS_PER_PAGE; rowsPerPage: State['rowsPerPage'] }
  | { type: ActionType.SET_DENSITY; density: State['density'] }
  | { type: ActionType.SET_CAPSULE_TYPE; capsuleType: State['capsuleType'] }
  | { type: ActionType.SET_PRODUCT_SIZE; productSize: State['productSize'] }
  | { type: ActionType.SET_SUPPLIER; supplier: State['supplier'] };

export const capsulePriceReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_PAGE:
      return {
        ...state,
        page: action.page,
      };

    case ActionType.SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.rowsPerPage,
      };

    case ActionType.SET_COUNT:
      return {
        ...state,
        count: action.count,
      };

    case ActionType.SET_DATA:
      return {
        ...state,
        data: action.data,
      };

    case ActionType.SET_SEARCH:
      return {
        ...state,
        search: action.search,
      };

    case ActionType.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.activeTab,
      };

    case ActionType.SET_DENSITY:
      return {
        ...state,
        density: action.density,
      };

    case ActionType.SET_CAPSULE_TYPE:
      return {
        ...state,
        capsuleType: action.capsuleType,
      };

    case ActionType.SET_PRODUCT_SIZE:
      return {
        ...state,
        productSize: action.productSize,
      };

    case ActionType.SET_SUPPLIER:
      return {
        ...state,
        supplier: action.supplier,
      };
  }
};
